<template>
  <div class="toggler">
    <button
      class="btn"
      :class="buttonClass"
      :title="title"
      :aria-label="title"
      @click="cycleTheme"
    >
      <i class="sr" :class="iconClass" />
    </button>
  </div>
</template>

<style lang="scss" src="../../sass/trade/theme_toggle.scss" />
<script charset="utf-8">
import { mapActions, mapState } from "vuex";
import { THEME_PREFERENCES } from "../store/modules/common";

const ICONS = {
  [THEME_PREFERENCES.SYSTEM]: "sr-monitor",
  [THEME_PREFERENCES.LIGHT]: "sr-sun",
  [THEME_PREFERENCES.DARK]: "sr-moon",
};

export default {
  computed: {
    ...mapState("common", ["dark", "themePreference"]),
    iconClass() {
      return ICONS[this.themePreference] || ICONS[THEME_PREFERENCES.SYSTEM];
    },
    buttonClass() {
      return this.dark ? "night" : "day";
    },
    title() {
      return this.$t("theme." + this.themePreference);
    },
  },
  methods: {
    ...mapActions("common", ["cycleTheme"]),
  },
};
</script>
